import React, { useState } from 'react';

import { FileUploader } from 'react-drag-drop-files';

import Button from '../Button';
import './styles.scoped.css';

const DEFAULT_FILE_TYPES = ['PDF'];

const FileUploadButton = ({
  func,
  setReceiptFile,
  receiptId,
  uploadStart,
  uploadEnd,
  uploadError,
  expenseId,
  fileTypes = DEFAULT_FILE_TYPES,
  maxSizeKb = process.env.REACT_APP_PDF_MAX_SIZE,
}) => {
  const [hasExceededSize, setHasExceededSize] = useState(false);
  const [hasAnotherExtension, setHasAnotherExtension] = useState(false);

  const handleChange = newFile => {
    setHasAnotherExtension(false);
    if (maxSizeKb && newFile?.size / 1024 > maxSizeKb) {
      setHasExceededSize(true);
    } else {
      setHasExceededSize(false);
      func({
        file: newFile,
        setReceiptFile: setReceiptFile,
        receiptId: receiptId,
        fileSize: newFile?.size / 1024,
        uploadStart: uploadStart,
        uploadEnd: uploadEnd,
        uploadError: uploadError,
        expenseId: expenseId,
      });
    }
  };

  const onTypeError = () => {
    setHasAnotherExtension(true);
    setHasExceededSize(false);
  };

  return (
    <div>
      <FileUploader handleChange={handleChange} name="file" types={fileTypes} onTypeError={onTypeError} classes="upload-btn">
        <Button variant="outline" text="Upload Or Drop A File Right Here" style={{ border: 'dashed', borderWidth: '1px', borderColor: '#C8102E', fontSize: '14px', width: '100%' }} />
      </FileUploader>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '2rem',
          maxWidth: 250,
        }}
      >
        {hasAnotherExtension && (
          <div style={{ fontSize: '12px', color: '#da0f2e' }}>
            File type is not supported. Please select a valid file and try again.
          </div>
        )}
        {hasExceededSize && (
          <div style={{ fontSize: '12px', color: '#da0f2e' }}>
            File size too large for upload. Please size down to {maxSizeKb} KB and try again.
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUploadButton;
